import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useAppraisal } from "./AppraisalContext";

export const CTAButton = ({ light = false, className = "", testId = "cta-book-appraisal", label = "Book Your Free Rental Appraisal" }) => {
  const { openDialog } = useAppraisal();
  const base = light
    ? "bg-kept-brass text-kept-ink"
    : "bg-kept-ink text-kept-brass";
  return (
    <motion.button
      onClick={openDialog}
      whileTap={{ scale: 0.98 }}
      className={`group inline-flex items-center gap-3 px-8 py-4 kept-label ${base} ${className}`}
      data-testid={testId}
    >
      {label}
      <ArrowRight
        size={15}
        className="transition-transform duration-300 group-hover:translate-x-1.5"
      />
    </motion.button>
  );
};

export default CTAButton;
